import type {FirebaseOptions} from 'firebase/app';
import {version} from '../../package.json';

export const environment = {
  production: false,
  version,
  name: 'development',
  tracingEnabled: false,
  /** Local mp-api (`npm run dev` + `.env.local`, default port 20017). */
  apiBaseUrl: 'http://localhost:20017/v3',
  // Firebase Analytics / Performance only in production builds.
  firebaseConfig: {} as FirebaseOptions,
};
